<template>
  <div id="coin_seller_payment_method_select">
    <van-nav-bar :title="coin_seller_payment_method_select" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row>
      <!--   列表   -->
      <van-col span="24">
        <van-col span="24" class="coin_seller_payment_method_select_bg">
          <van-col span="22" offset="1" class="coin_seller_payment_method_select_title">Select country & currency type</van-col>
          <van-col span="18" offset="1" class="coin_seller_payment_method_select_country">
            <img :src="currency.country_img"/> {{ currency.country_name }} <span> {{ currency.currency_name }}</span>
          </van-col>
          <van-col span="4" class="coin_seller_payment_method_select_i">
            <van-icon name="arrow" />
          </van-col>
        </van-col>
        <van-col span="22" offset="1" class="coin_seller_payment_method_select_type">
          <van-col span="22" offset="1" class="coin_seller_payment_method_select_type_title">Select Payment method that you can remit</van-col>
          <van-col span="22" offset="1" class="coin_seller_payment_method_select_type_list">
            <van-checkbox-group v-model="result">
              <van-cell-group>
                <van-cell
                    v-for="(item, index) in country_payment_list"
                    clickable
                    :key="index"
                    @click="toggle(index)"
                >
                  <template #title>
                    <div class="coin_seller_payment_method_select_type_left">
                      <img :src="item.img"/> {{ item.name }}
                    </div>
                  </template>
                  <template #right-icon>
                    <van-checkbox :name="item.id" ref="checkboxes" checked-color="#FF61F5"/>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </van-col>
        </van-col>
        <van-col span="24" class="coin_seller_payment_method_select_kf">
          <van-icon name="service-o" size="14px"/> {{ $t('column.tell_preferred_payment_method') }} <van-icon name="arrow" size="14px"/>
        </van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"

export default {
  data() {
    return {
      coin_seller_payment_method_select: undefined,
      currency_type_id: undefined,
      currency: {},
      result: [],
      country_payment_list: []
    }
  },
  created() {
    this.currency_type_id = this.$route.query.currency_type_id
    this.getList()
  },
  methods: {
    toggle(index){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=bind_payment_method",{
        params:{uid: uid, token: token, payment_method_id: this.country_payment_list[index].id }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status !==1){
          Toast(res.data.error)
          this.getList()
        }
      })
    },
    getList(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=get_country_payment_method",{
        params:{uid: uid, token: token, currency_type_id: this.currency_type_id }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status===1){
          this.list = res.data.data.list
          this.coin_seller_payment_method_select = res.data.data.currency.country_name + '-' + res.data.data.currency.currency_name
          this.currency = res.data.data.currency
          this.country_payment_list = res.data.data.country_payment_list
          this.result = res.data.data.selected
        }else{
          Toast(res.data.error)
        }
      })
    },
    onClickLeft() {
      // 返回上一页
      this.$router.go(-1);
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/payroll_seller_payment_method_select.vue